import { render, staticRenderFns } from "./Infaq.vue?vue&type=template&id=d328516a"
import script from "./Infaq.vue?vue&type=script&lang=js"
export * from "./Infaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports